'use client';

import React from 'react';

import { BrandWithCounts } from '@/services/filters/algolia/mappers';

import { MakeModelSearchFilter } from './make-model-search-filter';

export interface MakeModelSearchClientProps {
  brandsAndRanges: BrandWithCounts[];
  defaultMake?: string;
  defaultModel?: string;
}

export default function MakeModelSearchClient({
  brandsAndRanges,
  defaultMake,
  defaultModel,
}: MakeModelSearchClientProps) {
  return (
    <MakeModelSearchFilter
      brandsAndRanges={brandsAndRanges}
      defaultMake={defaultMake}
      defaultModel={defaultModel}
    />
  );
}
